export default class ProcessAnswer {

  id = null;

  processStep = null;
  processStepName = "";

  answer = "";

  constructor() {
  }
}
